/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import { Grid, Modal, Pagination } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CardDB from 'components/BiteDB/Cards/CardDB';
import TotalCard from 'components/BiteDB/Cards/TotalCard';
import QuickActionCard from 'components/BiteDB/Cards/QuickActionCard';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PriceCheckOutlinedIcon from '@mui/icons-material/PriceCheckOutlined';
import CreateDatabaseModal from './Modal/CreateDatabase';
import CircularProgress from '@mui/material/CircularProgress';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { IDatabase } from '../../api/bitedb/database/database';
import { GlobalContext } from 'providers/GlobalProvider';
import { useGetEntitiesByGroupId } from 'api/bitedb/entities/entities.hooks';
import { useGetStatsByGroupId } from 'api/bitedb/stats/stats.hooks';

interface DashboardProps {
  setAutoTab: (tab: string) => void;
  databases: IDatabase[] | undefined;
  nrOfTotalItems: number;
  peopleCount: number;
  tariffCount: number;
  isLoading: boolean;
  onRefresh: () => void;
  searchTerm: string;
  setSearchTerm: any;
  isScroll?: boolean;
  setIsScroll?: any;
  processingDatabases: Set<string>;
  onDatabaseCreated: (databaseId: string) => void;
  onDatabaseUploadFailed?: (databaseId: string) => void;
  onOfferLinkEntities?: (databaseId: string) => void;
}

const Dashboard: React.FC<DashboardProps> = ({
  setAutoTab,
  databases,
  nrOfTotalItems,
  peopleCount,
  tariffCount,
  isLoading,
  onRefresh,
  searchTerm,
  setSearchTerm,
  isScroll,
  setIsScroll,
  processingDatabases,
  onDatabaseCreated,
  onDatabaseUploadFailed,
  onOfferLinkEntities,
}) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const [showCreateDatabaseModal, setShowCreateDatabaseModal] =
    React.useState(false);

  const { data: stats } = useGetStatsByGroupId(
    cur_user?.selected_team?.id ?? '-1',
  );

  const [tab, setTab] = useState<string>('All');
  const [selectedTab, setSelectedTab] = useState<string>('All');
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    if (databases && databases.length > 0) {
      setCurrentItems(
        databases
          .filter(
            (item: { type: string }) =>
              selectedTab === 'All' || item.type === selectedTab,
          )
          .slice(indexOfFirstItem, indexOfLastItem),
      );
      setTotalPages(
        Math.ceil(
          databases.filter(
            (item: { type: string }) =>
              selectedTab === 'All' || item.type === selectedTab,
          ).length / itemsPerPage,
        ),
      );
    } else {
      setTotalPages(1);
      setCurrentPage(1);
    }
  }, [currentPage, itemsPerPage, databases, selectedTab]);

  useEffect(() => {
    const element = document.getElementById('your-databases-section');
    if (element && isScroll) {
      const elementPosition = element.offsetTop + 55;
      const offsetPosition = elementPosition;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      setIsScroll(false);
    }
  }, [isScroll]);

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const handleTabsSwitch = (type: string) => {
    switch (type) {
      case 'All':
        setTab('All');
        setSelectedTab('All');
        break;
      case 'People & Co.':
        setTab('People & Co.');
        setSelectedTab('people & companies');
        break;
      case 'Tariffs':
        setTab('Tariffs');
        setSelectedTab('tariffs');
        break;
      default:
        setTab('All');
        setSelectedTab('All');
    }
  };

  const getParagraphText = (database: any) => {
    let paragraphText = 'Never updated';

    if (database.last_screen_timestamp) {
      const lastScreenedDate = new Date(database.last_screen_timestamp);
      const today = new Date();

      // Reset hours to compare just the dates
      const lastScreenedDay = new Date(lastScreenedDate.setHours(0, 0, 0, 0));
      const todayDay = new Date(today.setHours(0, 0, 0, 0));

      if (lastScreenedDay.getTime() === todayDay.getTime()) {
        paragraphText = 'Today';
      } else {
        const diffTime = Math.abs(today.getTime() - lastScreenedDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        paragraphText = `Updated ${diffDays} day${
          diffDays !== 1 ? 's' : ''
        } ago`;
      }
    }
    return paragraphText;
  };

  const handlePageChange = (e: ChangeEvent<unknown>, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    if (Array.isArray(databases)) {
      setCurrentItems(databases.slice(indexOfFirstItem, indexOfLastItem));
    }
  };

  const goTo = () => {
    history.push({
      pathname: '/review-queue',
    });
  };

  return (
    <>
      <Grid container sx={{ p: 0 }}>
        <Grid item xs={12}>
          <div
            className='api-container-info'
            style={{ padding: '15px 0px 15px 0px' }}
          >
            <div className='card-grid'>
              <TotalCard
                svgIcon={
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M4 18V6'
                      stroke='var(--Primary-400, #4895ef)'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                    />
                    <path
                      d='M20 6V18'
                      stroke='var(--Primary-400, #4895ef)'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                    />
                    <path
                      d='M12 10C16.4183 10 20 8.20914 20 6C20 3.79086 16.4183 2 12 2C7.58172 2 4 3.79086 4 6C4 8.20914 7.58172 10 12 10Z'
                      stroke='var(--Primary-400, #4895ef)'
                      strokeWidth='1.5'
                    />
                    <path
                      d='M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12'
                      stroke='var(--Primary-400, #4895ef)'
                      strokeWidth='1.5'
                    />
                    <path
                      d='M20 18C20 20.2091 16.4183 22 12 22C7.58172 22 4 20.2091 4 18'
                      stroke='var(--Primary-400, #4895ef)'
                      strokeWidth='1.5'
                    />
                  </svg>
                }
                title={'Total Databases'}
                total={`${peopleCount + tariffCount}`}
                paragraph={`${tariffCount} Tariffs, ${peopleCount} Entities`}
                goTo={() => {
                  // setAutoTab('Databases');
                  const element = document.getElementById(
                    'your-databases-section',
                  );
                  if (element) {
                    const elementPosition = element.offsetTop + 55;
                    const offsetPosition = elementPosition;

                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth',
                    });
                  }
                }}
              />
              {!cur_user.selected_team?.attributes?.tier?.includes(
                'tariff database',
              ) && (
                <TotalCard
                  svgIcon={
                    <PeopleAltOutlinedIcon
                      sx={{
                        fontSize: 20,
                        color: 'var(--Primary-400, #4895ef)',
                      }}
                    />
                  }
                  title={'Total Entities'}
                  total={`${stats?.total_entities ?? 0}`}
                  paragraph={'Across all databases'}
                  goTo={() => setAutoTab('People & Companies')}
                />
              )}
              <TotalCard
                svgIcon={
                  <PriceCheckOutlinedIcon
                    sx={{
                      fontSize: 20,
                      color: 'var(--Primary-400, #4895ef)',
                    }}
                  />
                }
                title={'Total Tariffs'}
                total={`${stats?.total_tariffs ?? 0}`}
                paragraph={'Across all databases'}
                goTo={() => setAutoTab('Tariffs')}
              />
              <TotalCard
                svgIcon={
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M11.5 0.999992C10.9477 0.999992 10.5 1.44771 10.5 1.99999V2.99999H9.99998C7.23864 2.99999 4.99998 5.23824 4.99998 7.99975V11C4.99998 11.7377 4.76718 12.5722 4.39739 13.4148C4.03164 14.2482 3.55875 15.0294 3.14142 15.6439C2.38188 16.7624 2.85215 18.5301 4.40564 18.8103C5.42144 18.9935 6.85701 19.2115 8.54656 19.3527C8.54454 19.4015 8.54352 19.4506 8.54352 19.5C8.54352 21.433 10.1105 23 12.0435 23C13.9765 23 15.5435 21.433 15.5435 19.5C15.5435 19.4482 15.5424 19.3966 15.5402 19.3453C17.1921 19.204 18.596 18.9903 19.5943 18.8103C21.1478 18.5301 21.6181 16.7624 20.8586 15.6439C20.4412 15.0294 19.9683 14.2482 19.6026 13.4148C19.2328 12.5722 19 11.7377 19 11V7.99975C19 5.23824 16.7613 2.99999 14 2.99999H13.5V1.99999C13.5 1.44771 13.0523 0.999992 12.5 0.999992H11.5ZM12 19.5C12.5113 19.5 13.0122 19.4898 13.4997 19.4715C13.5076 20.2758 12.8541 20.9565 12.0435 20.9565C11.2347 20.9565 10.5803 20.2778 10.5872 19.4746C11.0473 19.491 11.5191 19.5 12 19.5ZM9.99998 4.99999C8.34305 4.99999 6.99998 6.34297 6.99998 7.99975V11C6.99998 12.1234 6.65547 13.2463 6.22878 14.2186C5.79804 15.2 5.25528 16.0911 4.79599 16.7675C4.78578 16.7825 4.78102 16.7969 4.77941 16.8113C4.77797 16.8242 4.77919 16.8362 4.78167 16.8458C6.3644 17.1303 9.00044 17.5 12 17.5C14.9995 17.5 17.6356 17.1303 19.2183 16.8458C19.2208 16.8362 19.222 16.8242 19.2206 16.8113C19.2189 16.7969 19.2142 16.7825 19.204 16.7675C18.7447 16.0911 18.2019 15.2 17.7712 14.2186C17.3445 13.2463 17 12.1234 17 11V7.99975C17 6.34297 15.6569 4.99999 14 2.99999H9.99998Z'
                      fill='var(--Primary-400, #4895ef)'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M16.0299 0.757457C16.1622 0.228068 16.7146 -0.102469 17.2437 0.0301341C17.3131 0.0476089 17.3789 0.0669732 17.4916 0.104886C17.6295 0.151258 17.8183 0.221479 18.0424 0.322098C18.4894 0.522794 19.0851 0.848127 19.6982 1.35306C20.9431 2.37831 22.2161 4.1113 22.495 6.9005C22.55 7.45005 22.149 7.94009 21.5995 7.99504C21.05 8.05 20.5599 7.64905 20.505 7.09951C20.2839 4.88869 19.3068 3.62168 18.4268 2.89692C17.9774 2.52686 17.5418 2.28969 17.2232 2.14664C17.0645 2.07538 16.9369 2.02841 16.8541 2.00057C16.8201 1.98913 16.7859 1.97833 16.7513 1.96858C16.2192 1.83203 15.8964 1.2912 16.0299 0.757457Z'
                      fill='var(--Primary-400, #4895ef)'
                    />
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M7.97014 0.757457C7.83619 0.221662 7.29326 -0.104099 6.75746 0.0298498C6.68765 0.0473468 6.62176 0.066766 6.5084 0.104885C6.37051 0.151257 6.1817 0.221478 5.9576 0.322097C5.51059 0.522793 4.91493 0.848125 4.30179 1.35306C3.05685 2.37831 1.78388 4.1113 1.50496 6.90049C1.45001 7.45003 1.85095 7.94008 2.40049 7.99503C2.95004 8.04998 3.44008 7.64904 3.49504 7.0995C3.71612 4.88869 4.69315 3.62168 5.57321 2.89692C6.02257 2.52686 6.45815 2.28969 6.77678 2.14664C6.93548 2.07538 7.06308 2.02841 7.14589 2.00057C7.17991 1.98913 7.21413 1.97833 7.24867 1.96858C7.78081 1.83203 8.10358 1.2912 7.97014 0.757457Z'
                      fill='var(--Primary-400, #4895ef)'
                    />
                  </svg>
                }
                title={'Uncleared High Risk Matches'}
                total={`${
                  (stats?.total_not_reviewed_entities || 0) +
                  (stats?.total_new_entities || 0)
                } `}
                paragraph={'In the last 7 days'}
                goTo={goTo}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div
            className='api-container'
            style={{ gap: '10px', padding: '0px 0px 0px 0px' }}
          >
            <div
              className='api-container-left'
              style={{ flex: '1', gap: '20px' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <div
                  className='api-container-left-h1'
                  id='your-databases-section'
                  style={{ paddingTop: '0px' }}
                >
                  Your Databases
                </div>
              </div>

              <div className='team-content-header'>
                <div className='team-content-search'>
                  <div className='screening-input-field-container'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='20'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <path
                        d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z'
                        stroke='var(--card-text)'
                        strokeWidth='1.66667'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    <input
                      placeholder='Search Databases'
                      id='primary'
                      type='text'
                      className='screening-input-field-content'
                      name='primary'
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                      }}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                          // Additional action on Enter if needed
                        }
                      }}
                    />
                  </div>
                </div>
                <div
                  className='home-search-frame-input-action-cont-sec'
                  style={{
                    borderRadius: 'var(--radius-full, 9999px)',
                    border: '1.5px solid var(--Primary-400, #4895ef)',
                    marginTop: '5px',
                  }}
                >
                  <div
                    onClick={() => handleTabsSwitch('All')}
                    className={`home-search-frame-input-action-cont-btn ${
                      tab === 'All' ? 'selected' : ''
                    }`}
                  >
                    All
                  </div>
                  <div
                    onClick={() => handleTabsSwitch('People & Co.')}
                    className={`home-search-frame-input-action-cont-btn ${
                      tab === 'People & Co.' ? 'selected' : ''
                    }`}
                  >
                    Entities
                  </div>
                  <div
                    onClick={() => handleTabsSwitch('Tariffs')}
                    className={`home-search-frame-input-action-cont-btn ${
                      tab === 'Tariffs' ? 'selected' : ''
                    }`}
                  >
                    Tariffs
                  </div>
                </div>
              </div>
              <div
                className='audit-dashboard-cards-frame-box'
                style={{ width: '100%', height: '470px' }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <CircularProgress color='primary' />
                  </div>
                ) : databases && databases.length === 0 ? (
                  <div className='audit-dashboard-cards-no-ticket'>
                    No Databases Found
                  </div>
                ) : (
                  <div
                    className='audit-dashboard-cards-frame'
                    style={{ width: '100%' }}
                  >
                    {currentItems.map((database: any, index: number) => {
                      const isProcessing = processingDatabases.has(
                        database.id.toString(),
                      );
                      return (
                        <CardDB
                          key={index}
                          id={database.id}
                          svgIcon={
                            database.type === 'tariffs' ? (
                              <PriceCheckOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  color: 'var(--Primary-400, #4895ef)',
                                }}
                              />
                            ) : (
                              <PeopleAltOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  color: 'var(--Primary-400, #4895ef)',
                                }}
                              />
                            )
                          }
                          title={database.name}
                          paragraph={getParagraphText(database)}
                          total={(
                            (parseInt(database.nr_people_and_companies, 10) ||
                              0) +
                            (parseInt(database.nr_products, 10) || 0) +
                            (parseInt(database.nr_tariffs, 10) || 0)
                          ).toString()}
                          category={database.type}
                          isProcessing={isProcessing}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
              {databases && databases.length > 9 && (
                <div className='hb-pagination' style={{ width: '100%' }}>
                  <Pagination
                    onChange={handlePageChange}
                    size='large'
                    count={totalPages}
                    shape='rounded'
                    variant='text'
                    page={currentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div
            className='api-container'
            style={{ gap: '10px', padding: '0px 0px 15px 0px' }}
          >
            <div className='api-container-left' style={{ flex: '2' }}>
              <h1 style={{ paddingTop: '0px' }}>Quick Actions</h1>
              <div className='card-grid-three'>
                <QuickActionCard
                  svgIcon={
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M4 18V6'
                        stroke='var(--Primary-400, #4895ef)'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                      />
                      <path
                        d='M20 6V18'
                        stroke='var(--Primary-400, #4895ef)'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                      />
                      <path
                        d='M12 10C16.4183 10 20 8.20914 20 6C20 3.79086 16.4183 2 12 2C7.58172 2 4 3.79086 4 6C4 8.20914 7.58172 10 12 10Z'
                        stroke='var(--Primary-400, #4895ef)'
                        strokeWidth='1.5'
                      />
                      <path
                        d='M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12'
                        stroke='var(--Primary-400, #4895ef)'
                        strokeWidth='1.5'
                      />
                      <path
                        d='M20 18C20 20.2091 16.4183 22 12 22C7.58172 22 4 20.2091 4 18'
                        stroke='var(--Primary-400, #4895ef)'
                        strokeWidth='1.5'
                      />
                    </svg>
                  }
                  title={'Create Database'}
                  paragraph={'Add a new supplier database'}
                  btnTitle={'Create'}
                  goTo={() => setShowCreateDatabaseModal(true)}
                />
                <QuickActionCard
                  svgIcon={
                    <NotificationsActiveOutlinedIcon
                      sx={{
                        fontSize: 20,
                        color: 'var(--Primary-400, #4895ef)',
                      }}
                    />
                  }
                  title={'Run Screening'}
                  paragraph={'Screen your databases for potential risks'}
                  btnTitle={'Screen'}
                  goTo={() =>
                    history.push({
                      pathname: '/screening-setting',
                      state: { linkTab: 'Run Screening' },
                    })
                  }
                />
                <QuickActionCard
                  svgIcon={
                    <AccessTimeOutlinedIcon
                      sx={{
                        fontSize: 20,
                        color: 'var(--Primary-400, #4895ef)',
                      }}
                    />
                  }
                  title={'Schedule'}
                  paragraph={'Set up automated periodic screening'}
                  btnTitle={'Schedule'}
                  goTo={() =>
                    history.push({
                      pathname: '/screening-setting',
                      state: { linkTab: 'Schedule' },
                    })
                  }
                />
              </div>
            </div>
            <div style={{ flex: '1' }}></div>
          </div>
        </Grid>
      </Grid>
      <Modal
        open={showCreateDatabaseModal}
        onClose={() => setShowCreateDatabaseModal(false)}
      >
        <div style={{ outline: 'none' }}>
          <CreateDatabaseModal
            open={showCreateDatabaseModal}
            handleClose={() => setShowCreateDatabaseModal(false)}
            handleRefresh={handleRefresh}
            onDatabaseCreated={onDatabaseCreated}
            onDatabaseUploadFailed={onDatabaseUploadFailed}
            onOfferLinkEntities={onOfferLinkEntities}
          />
        </div>
      </Modal>
    </>
  );
};

export default Dashboard;
